import React, { useState } from "react";
import {
  CuerpoCalendario,
  ContenedorCalendario,
  DiasSemana,
  Dia,
  HoraFila,
  Evento,
  VistaBotones,
  Navegacion,
  BotonHoy,
  BotonAgregar,
  NombrePaciente,
  Precio,
  AccionIcono,
  ModalOverlay,
  ModalContent,
} from "../Css/StyledCalendario";

const Calendario = () => {
  const [diaSeleccionado, setDiaSeleccionado] = useState("2025-08-31");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [citas, setCitas] = useState([
    {
      fecha: "2025-08-31",
      horaInicio: "14:00",
      horaFin: "14:45",
      paciente: "María García",
      precio: 0,
      acciones: ["x"],
    },
    {
      fecha: "2025-08-31",
      horaInicio: "15:00",
      horaFin: "15:45",
      paciente: "Juan Garay",
      precio: 5000,
      acciones: ["editar"],
    },
    {
      fecha: "2025-09-01",
      horaInicio: "10:00",
      horaFin: "10:45",
      paciente: "Ana López",
      precio: 3000,
      acciones: ["editar", "x"],
    },
  ]);

  const dias = [
    { nombre: "L", fecha: "2025-08-30" },
    { nombre: "M", fecha: "2025-08-31" },
    { nombre: "M", fecha: "2025-09-01" },
    { nombre: "J", fecha: "2025-09-02" },
    { nombre: "V", fecha: "2025-09-03" },
    { nombre: "S", fecha: "2025-09-04" },
    { nombre: "D", fecha: "2025-09-05" },
  ];

  const citasDelDia = citas.filter((c) => c.fecha === diaSeleccionado);

  // --- Función para agregar nueva cita ---
  const handleAgregarCita = (e) => {
    e.preventDefault();
    const form = e.target;
    const fecha = form.fecha.value;
    const horaInicio = form.hora.value;

    // calcular hora fin (45 minutos después)
    const [h, m] = horaInicio.split(":").map(Number);
    const fin = new Date(0, 0, 0, h, m + 45);
    const horaFin = `${fin.getHours().toString().padStart(2, "0")}:${fin
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    const nuevaCita = {
      fecha,
      horaInicio,
      horaFin,
      paciente: form.paciente.value,
      precio: null,
      acciones: ["editar", "x"],
    };

    setCitas([...citas, nuevaCita]);
    setMostrarModal(false);
  };

  return (
    <CuerpoCalendario>
      <ContenedorCalendario>
        {/* Encabezado de días */}
        <DiasSemana>
          {dias.map((d, i) => (
            <Dia
              key={i}
              seleccionado={d.fecha === diaSeleccionado}
              onClick={() => setDiaSeleccionado(d.fecha)}
            >
              <span>{d.nombre}</span>
              <span>{new Date(d.fecha).getDate()}</span>
            </Dia>
          ))}
        </DiasSemana>

        {/* Turnos */}
        <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
          {citasDelDia.map((t, i) => (
            <HoraFila key={i}>
              <span>
                {t.horaInicio} a {t.horaFin}
              </span>
              {t.paciente && (
                <Evento>
                  <NombrePaciente>{t.paciente}</NombrePaciente>
                  <Precio>
                    {t.precio !== null ? `$${t.precio.toLocaleString()}` : ""}
                  </Precio>
                  <div>
                    {t.acciones.includes("editar") && (
                      <AccionIcono color="#d9534f">✏️</AccionIcono>
                    )}
                    {t.acciones.includes("x") && (
                      <AccionIcono color="#555">❌</AccionIcono>
                    )}
                  </div>
                </Evento>
              )}
            </HoraFila>
          ))}
        </div>

        {/* Botones de navegación */}
        <VistaBotones>
          <button>MES</button>
          <button>SEMANA</button>
          <button>DÍA</button>
        </VistaBotones>
        <Navegacion>
          <BotonHoy>HOY</BotonHoy>
          <button onClick={() => console.log("Anterior")}>◀</button>
          <button onClick={() => console.log("Siguiente")}>▶</button>
        </Navegacion>
        <BotonAgregar onClick={() => setMostrarModal(true)}>+</BotonAgregar>
      </ContenedorCalendario>

      {/* Modal para agregar cita */}
      {mostrarModal && (
        <ModalOverlay>
          <ModalContent>
            <h3>Nueva Cita</h3>
            <form onSubmit={handleAgregarCita}>
              <label>Fecha:</label>
              <input type="date" name="fecha" required defaultValue={diaSeleccionado} />

              <label>Hora inicio:</label>
              <input type="time" name="hora" required />

              <label>Paciente:</label>
              <input type="text" name="paciente" required />

              <div style={{ marginTop: "1rem" }}>
                <button type="submit">Guardar</button>
                <button type="button" onClick={() => setMostrarModal(false)}>
                  Cancelar
                </button>
              </div>
            </form>
          </ModalContent>
        </ModalOverlay>
      )}
    </CuerpoCalendario>
  );
};

export default Calendario;
